
import React, { useState, useEffect, useRef } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import Swal from 'sweetalert2';


import './ModalSeparators.css'


function ModalSeparators({ separators, formatJsonToAddShoppingCart }) {
    const [show, setShow] = useState(false);


    const selectSeparator = (separator) => {

        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: false
        })

        swalWithBootstrapButtons.fire({
            title: 'Separador de productos',
            text: '¿Estas seguro de agregar este separador?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si!',
            cancelButtonText: 'No!',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                swalWithBootstrapButtons.fire(
                    'Separador agregador',
                    '',
                    'success'
                )


                formatJsonToAddShoppingCart(separator)
                setShow(false)
            } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
            ) {
                swalWithBootstrapButtons.fire(
                    'Cancelaste el separador',
                    '',
                    'info'
                )
            }
        })
    }





    return (
        <>


            {/* <button
                className="sp-sep__trigger"
                onClick={() => setShow(true)}
                title="Separador de productos"
            >
                <i className="uil uil-align-center-v"></i> Separador
            </button> */}

            <button
                onClick={() => setShow(true)}
                title="Separador de productos"
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 7,
                    width: 'auto',
                    height: 'auto',
                    flexShrink: 0,
                    whiteSpace: 'nowrap',
                    lineHeight: 1,
                    padding: '8px 14px',
                    border: '1px solid #EBEEF3',
                    borderRadius: 10,
                    background: '#fff',
                    color: '#5B6B82',
                    fontSize: 12.5,
                    fontWeight: 600,
                    cursor: 'pointer',
                }}
            >
                <i className="uil uil-align-center-v"></i>
                <span>Separador</span>
            </button>

            <Modal
                show={show}
                size="md"
                centered
                onHide={() => (setShow(false))}
                dialogClassName="sp-sep-dialog"
                contentClassName="sp-sep-content"
            >
                <Modal.Body className="sp-sep">

                    {/* Encabezado */}
                    <div className="sp-sep__head">

                        <h1 className="sp-sep__title">Separador de productos</h1>
                        <button className="sp-sep__x" onClick={() => setShow(false)} aria-label="Cerrar" type="button">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    <p className="sp-sep__subtitle">Selecciona un separador para agrupar los productos</p>

                    {/* Lista de separadores */}
                    <div className="sp-sep__grid">
                        {separators.map((separator, index) => (
                            <button
                                key={index}
                                type="button"
                                className="sp-sep__item"
                                onClick={() => (selectSeparator(separator))}
                            >
                                <span className="sp-sep__item-ic"><i className="uil uil-arrow-from-top"></i></span>
                                <span className="sp-sep__item-name">{separator.name}</span>
                            </button>
                        ))}

                        {separators.length === 0 && (
                            <div className="sp-sep__empty"><i className="uil uil-align-center-v"></i> No hay separadores disponibles</div>
                        )}
                    </div>

                </Modal.Body>
            </Modal>


        </>
    )
}

export default ModalSeparators